
import { mapState, mapActions } from 'vuex'
import OrderHeader from '../OrderHeader'
import LocationSelected from '../LocationSelected.vue'
import LocationSelectedDelivery from '../LocationSelectedDelivery.vue'
import HandoffModeSelector from '../HandoffModeSelector'
import OrderTimePicker from '../OrderTimePicker.vue'
import Icon from '../Icon'
import CartProduct from '../CartProduct'
import SingleProduct from '../SingleProduct'
import Upsells from '../Upsells'
import CheckoutOffers from '../../cart/checkout/elements/CheckoutOffers.vue'
import AccordionItem from '../../common/AccordionItem'
import EarliestAvailable from '../../common/EarliestAvailable'

export default {
  props: {
    config: {
      type: Object,
      default: () => { }
    },
    layout: {
      type: String,
      default: null
    },
  },
  components: {
    EarliestAvailable,
    Icon,
    Upsells,
    CartProduct,
    OrderHeader,
    SingleProduct,
    OrderTimePicker,
    LocationSelected,
    HandoffModeSelector,
    LocationSelectedDelivery,
    CheckoutOffers,
    AccordionItem,
  },


  computed: {
    ...mapState(['location', 'order', 'cart', 'showCart', 'user', 'token', 'appInfo', 'isUpsellsView', 'isUpsellsModalView', 'menu']),
    ...mapState({
      upsells: state => state.checkout.upsells,
      handoffMode: state => state.order.handoffMode,
      rewards: state => state.checkout.rewards,
      tableposref: state => state.locations.tableposref,
    }),

    orderedRewards() {
      const data = [...this.rewards]
      const sortedData = data.sort((a, b) => {
        if (a.expires && !b.expires) {
          return -1
        }
        if (!a.expires && b.expires) {
          return 1
        }
        if (!a.expires && !b.expires) {
          return 0
        }

        const dateA = moment(a.expires, 'YYYYMMDD HH:mm').toDate()
        const dateB = moment(b.expires, 'YYYYMMDD HH:mm').toDate()

        return dateA - dateB
      })
      return sortedData
    },
    isDineIn() {
      return this.handoffMode === 'dinein'
    },
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    locationSelectedAction() {
      return {
        show: this.isMobile ? false : true,
        classes: 'btn primary link',
        text: 'Change location',
        icon: 'navigation-icon',
        callback: this.changeLocation,
      }
    },
    appHandoffModes() {
      return this.appInfo.order['handoff_modes']
    },
    locationHandoffModes() {
      if (this.location) {
        return this.$utils.locationHandoffModes(this.location, this.appHandoffModes)
      }

      return []
    },
    appSubHandoffModes() {
      if (this.appHandoffModes && this.appHandoffModes.length > 0) {
        const handoffFound = this.appHandoffModes.find(handoff => handoff.sub_handoff_modes_keys && handoff.sub_handoff_modes_keys.includes(this.handoffMode))
        if (handoffFound && handoffFound.sub_handoff_modes && handoffFound.sub_handoff_modes.length > 0) {
          return handoffFound.sub_handoff_modes
        }
      }
      return []
    },
    locationSubHandoffModes() {
      if (this.location) {
        return this.$utils.locationHandoffModes(this.location, this.appSubHandoffModes)
      }

      return []
    },
    isLocationSelectedDelivery() {
      return this.cart?.handoff === 'delivery' || this.order?.handoffMode === 'annex'
    },
    showHandoffMode() {
      return this.appInfo?.checkout?.show_handoff_mode
    },
    checkoutBtnText() {
      if (this.config?.headerInfo?.showEmptyCartImage && !this.cart?.products?.length) {
        return 'Browse Menu'
      } else {
        return this.cart?.totals?.total
          ? `Proceed to Checkout • ${this.$utils.currency(this.cart.totals.total)}`
          : 'Proceed to Checkout'
      }

    },
    isMultribrand() {
      return this.appInfo?.menu?.is_multibrand
    },
    superCategoryProducts() {
      if (!this.isMultribrand) {
        return [];
      }

      const superCategories = {};

      for (const cartProduct of this.cart.products || []) {
        const category = (this.menu?.categories || []).find(cat => 
          cat.products.some(p => p.product_id === cartProduct.product_id)
        );

        if (category && category.super_category) {
          if (!superCategories[category.super_category]) {
            superCategories[category.super_category] = {
              superCategoryName: category.super_category,
              superCategoryImage: this.config?.multibrandInfo?.useInactiveImage ? category.super_category_image_inactive : category.super_category_image_active,
              products: []
            };
          }

          superCategories[category.super_category].products.push(cartProduct);
        }
      }

      return Object.values(superCategories) || [];
    }
  },
  methods: {
    ...mapActions(['hideCart', 'selfUpsellsView', 'selfUpsellsModalView']),
    ...mapActions({
      getCartUpsells: 'checkout/getCartUpsells',
      validateCart: 'checkout/validateCart',
      getCartRewards: 'checkout/getCartRewards',
    }),

    async goTo() {
      await this.getCartUpsells()
      if (this.config?.headerInfo?.showEmptyCartImage && !this.cart?.products?.length) {
        this.hide()
        this.$router.push(`/menu`)
      } else if (this.config?.cartSelfUpsells?.enabledIndependentview && !this.isUpsellsView && this.upsells?.length > 0) {
        this.selfUpsellsView(true);
      } else if (this.config?.cartSelfModalUpsells?.enabledIndependentview && !this.isUpsellsModalView && this.upsells?.length > 0) {
        console.log('selfUpsellsModalView true')
        this.selfUpsellsModalView(true);
      } else {
        this.hide()
        this.$router.push('/order/checkout')
        this.selfUpsellsView(false);
        this.selfUpsellsModalView(false);
      }
    },
    goToMenu() {
      this.hide()
      this.$router.push(`/menu/${this.cart.menu_id}`)
    },
    hide() {
      document.body.style.overflow = 'auto'
      this.hideCart();
    },
    changeLocation() {
      this.hide()
      this.$router.push('/locations')
    },
  },
  watch: {
    async showCart() {
      if (this.showCart && (this.upsells && this.upsells.length == 0)) {
        await this.getCartUpsells()
      }
    },
  },

  async beforeMount() {

    const promisses = []
    if (this.upsells && this.upsells.length === 0) {
      promisses.push(this.getCartUpsells())
    }
    // Making sure that getCartRewards is only for logged users
    if (this.user && this.token) {
      promisses.push(this.getCartRewards())
    }
    if (promisses.length > 0) {
      await Promise.all(promisses)
    }
  },
}
